import React from 'react';
import { Modal } from 'react-bootstrap';
import { Common } from 'ws-scripts/modules/common';

import Hours from '../components/Hours';
import propDefs from '../proptypes';

class ModalComponent extends React.Component {
	constructor(props) {
		super(props);
		this.renderDelegate = this.renderDelegate.bind(this);
	}

	renderDelegate({ prefs, labels }) {
		const { hours, show, onHide } = this.props;
		return (
			<Modal show={show} className="modal-in-dialog" onHide={onHide}>
				<Modal.Header closeButton>
					<Modal.Title>{labels.get('HOURS')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Hours hours={hours} prefs={prefs} />
				</Modal.Body>
			</Modal>
		);
	}

	render() {
		return <Common render={this.renderDelegate} />;
	}
}

ModalComponent.defaultProps = {
	show: propDefs.defaults.show,
	hours: propDefs.defaults.hours,
	onHide: propDefs.defaults.onHide
};

ModalComponent.propTypes = {
	show: propDefs.settings.show,
	onHide: propDefs.settings.onHide,
	hours: propDefs.settings.hours
};

export default ModalComponent;



// WEBPACK FOOTER //
// ./src/components/ModalComponent.jsx